export default __webpack_public_path__ + "static/media/tilenga.41605462.jpg";